import {flexRender, Header} from "@tanstack/react-table";
import * as React from "react";

interface props {
    header: Header<any, any>,
}

const TanStackColumnHeader: React.FC<props> = ({header}) => {

    return (
        <div
            {...{
                className: header.column.getCanSort()
                    ? 'cursor-pointer select-none'
                    : '',
                onClick: header.column.getToggleSortingHandler(),
            }}
        >
            {flexRender(
                header.column.columnDef.header,
                header.getContext()
            )}
            {{
                asc: ' 🔼',
                desc: ' 🔽',
            }[header.column.getIsSorted() as string] ?? null}
        </div>
    )
}

export default TanStackColumnHeader ;
